// localStorage keys shared across services. Kept dependency-free so it can be
// imported by AuthenticationService without creating a circular dependency.
export const ACTIVE_COMPANY_KEY = "senri_active_company_id";
